// import React, { useMemo, useRef, useState } from "react";
// import { BsFiletypePdf } from "react-icons/bs";
// import PortalModal from "../PortalModal";
// import img from "../../Assets/Logos/profile3.jpg";
// import { QRCodeCanvas } from "qrcode.react";
// import logo from "../../Assets/Logos/ashok.png";
// import html2pdf from "html2pdf.js";
// import { toast } from "react-toastify";
// import axios from "axios";
// import { useEffect } from "react";
// import PanCardPdf from "../PanCardPdf";
// import jsPDF from "jspdf";
// import html2canvas from "html2canvas";

// const REACT_APP_CLOUDINARY_UPLOAD_URL =
//   process.env.REACT_APP_CLOUDINARY_UPLOAD_URL;
// const REACT_APP_CLOUDINARY_UPLOAD_PRESET =
//   process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

// export default function PanCard() {
//   const [panNo, setPanNo] = useState("");
//   const [history, setHistory] = useState([]);
//   const previewRef = useRef(null);
//   const pdfRef = useRef(null);
//   const fileInputRef = useRef(null);
//   const signatureInputRef = useRef(null);
//   const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

//   const [panPrice, setPanPrice] = useState(null);
//   const [panAccess, setPanAccess] = useState(false);
//   const [allHistory, setAllHistory] = useState([]);
//   const [filteredHistory, setFilteredHistory] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [panData, setPanData] = useState(null);
//   const [showCard, setShowCard] = useState(false);
//   const panCardRef = useRef(null);
//   const [showConfirmationModal, setShowConfirmationModal] = useState(false);
//   const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);
//   const [filters, setFilters] = useState({
//     search: "",
//     status: "",
//     fromDate: "",
//     toDate: "",
//   });

//   const [uploading, setUploading] = useState(false);
//   const [uploadedImageUrl, setUploadedImageUrl] = useState("");
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [uploadedSignatureUrl, setUploadedSignatureUrl] = useState("");
//   const [selectedSignatureFile, setSelectedSignatureFile] = useState(null);

//   const fetchPriceData = async () => {
//     try {
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/services/access-check`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );
//       setPanAccess(response.data?.serviceAccess.includes("pan"));
//       setPanPrice(response?.data?.servicePrices?.pan);
//       //console.log(
//       //   "--------------response.data?.servicePrices?.pan",
//       //   response?.data?.servicePrices?.pan,
//       // );
//     } catch (e) {
//       console.error("Error fetching data:", e);
//     }
//   };

//   const fetchData = async () => {
//     try {
//       setIsLoading(true);
//       const response = await axios.get(
//         `${process.env.REACT_APP_API_URL}/services/get-document-records?service=pan`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       const historyData = response.data.map((item) => ({
//         date: new Date(item.createdAt).toLocaleString(),
//         panNo: item.idNumber,
//         name: item.apiResponse?.name || "N/A",
//         details: "PAN Verification",
//         status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
//         error: item.status === "failed" ? "Verification failed" : "",
//         createdAt: new Date(item.createdAt),
//       }));

//       setAllHistory(historyData);
//       setFilteredHistory(historyData);
//       setHistory(historyData);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//       toast.error("Failed to fetch history");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//     fetchPriceData();
//   }, []);

//   useEffect(() => {
//     applyFilters();
//   }, [filters]);

//   const handleSubmit = async () => {
//     if (!panNo.trim()) {
//       toast.error("Please enter PAN number");
//       return;
//     }
//     if (!panAccess) {
//       toast.error("You don't have access to this service");
//       return;
//     }
//     if (!selectedFile) {
//       toast.error("Please upload a photo first");
//       return;
//     }

//     try {
//       setUploading(true);

//       const photoFormData = new FormData();
//       photoFormData.append("file", selectedFile);
//       photoFormData.append("upload_preset", REACT_APP_CLOUDINARY_UPLOAD_PRESET);

//       const photoRes = await axios.post(
//         REACT_APP_CLOUDINARY_UPLOAD_URL,
//         photoFormData,
//       );
//       const imageUrl = photoRes.data.secure_url;
//       setUploadedImageUrl(imageUrl);

//       if (selectedSignatureFile) {
//         const signatureFormData = new FormData();
//         signatureFormData.append("file", selectedSignatureFile);
//         signatureFormData.append(
//           "upload_preset",
//           REACT_APP_CLOUDINARY_UPLOAD_PRESET,
//         );

//         const signatureRes = await axios.post(
//           REACT_APP_CLOUDINARY_UPLOAD_URL,
//           signatureFormData,
//         );
//         const signatureUrl = signatureRes.data.secure_url;
//         setUploadedSignatureUrl(signatureUrl);
//       }

//       toast.success("Photo uploaded successfully!");
//       setShowConfirmationModal(true);
//     } catch (error) {
//       console.error("Upload failed:", error);
//       toast.error("Upload failed. Please try again.");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const proceedWithApiCall = async () => {
//     if (!panNo.trim()) {
//       toast.error("Please enter PAN number");
//       return;
//     }

//     setIsLoading(true);
//     setError("");
//     setPanData(null);

//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/services/pan/pan-comprehensive-verification`,
//         {
//           id_number: panNo,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         },
//       );

//       if (response.data.success === false) {
//         throw new Error(response.data.message || "Failed to fetch PAN data");
//       }

//       setPanData(response.data.data);
//       setShowCard(true);

//       const newEntry = {
//         date: new Date().toLocaleString(),
//         panNo: response.data.data.pan_number,
//         name: response.data.data.full_name || "N/A",
//         dob: response.data.data.dob || "N/A",
//         status: "Success",
//       };

//       setAllHistory((prev) => [newEntry, ...prev]);
//       setFilteredHistory((prev) => [newEntry, ...prev]);
//       setHistory((prev) => [newEntry, ...prev]);

//       toast.success("PAN data fetched successfully");
//     } catch (err) {
//       console.error("Error fetching PAN data:", err);

//       let errorMessage = "Failed to fetch PAN data. Please try again.";
//       if (err.response) {
//         if (err.response.data && err.response.data.message) {
//           errorMessage = err.response.data.message;
//         } else if (err.response.status === 401) {
//           errorMessage = "Unauthorized - Please login again";
//         } else if (err.response.status === 403) {
//           errorMessage = "Forbidden - You don't have permission";
//         } else if (err.response.status === 404) {
//           errorMessage = "Service not found";
//         } else if (err.response.status === 500) {
//           errorMessage = "Server error - Please try again later";
//         }
//       } else if (err.request) {
//         errorMessage = "Network error - Please check your connection";
//       }

//       toast.error(errorMessage);

//       const newEntry = {
//         date: new Date().toLocaleString(),
//         panNo,
//         status: "Failed",
//         error: errorMessage,
//       };

//       setAllHistory((prev) => [newEntry, ...prev]);
//       setFilteredHistory((prev) => [newEntry, ...prev]);
//       setHistory((prev) => [newEntry, ...prev]);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useEffect(() => {
//     applyFilters();
//   }, [filters, allHistory]);

//   const applyFilters = () => {
//     let filteredData = [...allHistory];

//     if (filters.search) {
//       const searchTerm = filters.search.toLowerCase();
//       filteredData = filteredData.filter(
//         (item) =>
//           item.panNo.toLowerCase().includes(searchTerm) ||
//           (item.name && item.name.toLowerCase().includes(searchTerm)),
//       );
//     }

//     if (filters.status) {
//       filteredData = filteredData.filter(
//         (item) => item.status.toLowerCase() === filters.status.toLowerCase(),
//       );
//     }

//     if (filters.fromDate || filters.toDate) {
//       const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
//       const toDate = filters.toDate ? new Date(filters.toDate) : null;

//       if (fromDate) fromDate.setHours(0, 0, 0, 0);
//       if (toDate) toDate.setHours(23, 59, 59, 999);

//       filteredData = filteredData.filter((item) => {
//         const itemDate = new Date(item.createdAt);
//         let matches = true;

//         if (fromDate && itemDate < fromDate) matches = false;
//         if (toDate && itemDate > toDate) matches = false;

//         return matches;
//       });
//     }

//     setFilteredHistory(filteredData);
//     setCurrentPage(1);
//   };

//   const clearFilters = () => {
//     setFilters({
//       search: "",
//       status: "",
//       fromDate: "",
//       toDate: "",
//     });
//     setFilteredHistory(allHistory);
//     setCurrentPage(1);
//   };

//   const handleDownloadPDF = async () => {
//     if (isDownloadingPDF) {
//       toast.warning("PDF download is already in progress");
//       return;
//     }

//     if (!pdfRef.current || !panData) {
//       toast.error("Nothing to download");
//       return;
//     }

//     try {
//       setIsDownloadingPDF(true);

//       await new Promise((res) => setTimeout(res, 300));

//       const canvas = await html2canvas(pdfRef.current, {
//         scale: 2,
//         useCORS: true,
//         backgroundColor: "#ffffff",
//       });

//       const imgData = canvas.toDataURL("image/png");

//       const pdf = new jsPDF("portrait", "pt", "a4");
//       const pageWidth = pdf.internal.pageSize.getWidth();
//       const pageHeight = pdf.internal.pageSize.getHeight();

//       const ratio = Math.min(
//         pageWidth / canvas.width,
//         pageHeight / canvas.height,
//       );
//       const imgWidth = canvas.width * ratio;
//       const imgHeight = canvas.height * ratio;

//       const marginX = (pageWidth - imgWidth) / 2;
//       const marginY = 30;

//       pdf.addImage(imgData, "PNG", marginX, marginY, imgWidth, imgHeight);
//       pdf.save(`PAN-${panData.pan_number || "Card"}.pdf`);

//       toast.success("PAN Card PDF downloaded successfully!");

//       setTimeout(() => {
//         setPanNo("");
//         setSelectedFile(null);
//         setSelectedSignatureFile(null);
//         setUploadedImageUrl("");
//         setUploadedSignatureUrl("");
//         setPanData(null);
//         setShowCard(false);

//         // Reset file input elements
//         if (fileInputRef.current) {
//           fileInputRef.current.value = "";
//         }
//         if (signatureInputRef.current) {
//           signatureInputRef.current.value = "";
//         }
//       }, 500);
//     } catch (error) {
//       console.error("Error generating PDF:", error);
//       toast.error("Failed to generate PAN Card PDF. Please try again.");
//     } finally {
//       setIsDownloadingPDF(false);
//     }
//   };

//   const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
//   const currentData = filteredHistory.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage,
//   );

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const [year, month, day] = dateString.split("-");
//     return `${day}/${month}/${year}`;
//   };

//   const handleFileUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedFile(file);
//     }
//   };

//   const handleSignatureUpload = (e) => {
//     const file = e.target.files[0];
//     if (file) {
//       setSelectedSignatureFile(file);
//     }
//   };

//   const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNext = () =>
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const visiblePages = useMemo(() => {
//     const delta = 2;
//     const pages = [];
//     for (
//       let i = Math.max(1, currentPage - delta);
//       i <= Math.min(totalPages, currentPage + delta);
//       i++
//     ) {
//       pages.push(i);
//     }
//     return pages;
//   }, [currentPage, totalPages]);

//   const qrText = panData
//     ? `
// नाम / Name : ${panData.full_name.toUpperCase()} ,
// पिता का नाम / Father's Name : ${panData.father_name.toUpperCase()},
// जन्म की तारीख / Date of Birth : ${formatDate(panData.dob)},
// पैन / PAN : ${panData.pan_number}
// `.trim()
//     : "";
//   //console.log("---------------", panPrice);

//   return (
//     <div className="py-4 w-full">
//       <div className="bg-blue-100 p-2 mb-4">
//         <h2 className="text-center text-xl font-semibold text-blue-700">
//           Download PAN Card
//         </h2>
//       </div>
//       <div className="py-4 space-y-4">
//         <div className="w-full">
//           <label className="block text-sm font-medium text-gray-700 mb-2">
//             PAN Number <span className="text-red-500">*</span>
//           </label>
//           <input
//             type="text"
//             placeholder="Enter PAN No"
//             value={panNo}
//             onChange={(e) => setPanNo(e.target.value.toUpperCase())}
//             className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
//             maxLength={10}
//           />
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload Photo <span className="text-red-500">*</span>
//             </label>
//             <div className="relative">
//               <input
//                 ref={fileInputRef}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleFileUpload}
//                 className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer border border-gray-300 rounded-md pr-10"
//               />
//               {selectedFile && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSelectedFile(null);
//                     if (fileInputRef.current) {
//                       fileInputRef.current.value = "";
//                     }
//                   }}
//                   className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-700 font-bold text-lg"
//                   title="Remove photo"
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//             {selectedFile && (
//               <p className="mt-1 text-xs text-green-600">
//                 ✓ {selectedFile.name}
//               </p>
//             )}
//           </div>

//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-2">
//               Upload Signature
//             </label>
//             <div className="relative">
//               <input
//                 ref={signatureInputRef}
//                 type="file"
//                 accept="image/*"
//                 onChange={handleSignatureUpload}
//                 className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer border border-gray-300 rounded-md pr-10"
//               />
//               {selectedSignatureFile && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setSelectedSignatureFile(null);
//                     if (signatureInputRef.current) {
//                       signatureInputRef.current.value = "";
//                     }
//                   }}
//                   className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-700 font-bold text-lg"
//                   title="Remove signature"
//                 >
//                   ✕
//                 </button>
//               )}
//             </div>
//             {selectedSignatureFile && (
//               <p className="mt-1 text-xs text-green-600">
//                 ✓ {selectedSignatureFile.name}
//               </p>
//             )}
//           </div>
//         </div>

//         <button
//           onClick={handleSubmit}
//           disabled={isLoading || !panNo || !selectedFile || uploading}
//           className={`bg-indigo-600 text-white py-2 px-6 rounded hover:bg-indigo-700 transition-colors ${
//             isLoading || !panNo || !selectedFile || uploading
//               ? "opacity-70 cursor-not-allowed"
//               : ""
//           }`}
//         >
//           {uploading ? "Uploading..." : isLoading ? "Processing..." : "SUBMIT"}
//         </button>
//       </div>
//       <div className="bg-white p-4 shadow-md rounded-lg mb-4">
//         <h3 className="text-lg font-semibold mb-4">
//           PAN Card Download History
//         </h3>

//         <div className="bg-gray-50 p-4 rounded-lg mb-4">
//           <h4 className="text-md font-medium mb-3">Filter Current Results</h4>
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
//             <div>
//               <label className="block text-sm font-medium mb-1">Search</label>
//               <input
//                 type="text"
//                 placeholder="Search PAN number"
//                 value={filters.search}
//                 onChange={(e) =>
//                   setFilters({ ...filters, search: e.target.value })
//                 }
//                 className="w-full border border-gray-300 rounded px-3 py-2"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium mb-1">Status</label>
//               <select
//                 value={filters.status}
//                 onChange={(e) =>
//                   setFilters({ ...filters, status: e.target.value })
//                 }
//                 className="w-full border rounded px-3 py-2"
//               >
//                 <option value="">All Status</option>
//                 <option value="Success">Success</option>
//                 <option value="Failed">Failed</option>
//                 <option value="pending">Pending</option>
//               </select>
//             </div>
//             <div>
//               <label className="block text-sm font-medium mb-1">
//                 From Date
//               </label>
//               <input
//                 type="date"
//                 value={filters.fromDate}
//                 onChange={(e) =>
//                   setFilters({ ...filters, fromDate: e.target.value })
//                 }
//                 className="w-full border rounded px-3 py-2"
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-medium mb-1">To Date</label>
//               <input
//                 type="date"
//                 value={filters.toDate}
//                 onChange={(e) =>
//                   setFilters({ ...filters, toDate: e.target.value })
//                 }
//                 className="w-full border rounded px-3 py-2"
//               />
//             </div>
//           </div>

//           <div className="flex justify-end gap-2">
//             <button
//               onClick={clearFilters}
//               className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
//             >
//               Clear
//             </button>
//             <button
//               onClick={applyFilters}
//               className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//             >
//               Apply
//             </button>
//           </div>
//         </div>

//         <div className="overflow-x-auto">
//           <table className="w-full text-sm text-left">
//             <thead className="bg-gray-100 text-gray-700">
//               <tr>
//                 <th className="px-4 py-2">Sl No</th>
//                 <th className="px-4 py-2">Date & Time</th>
//                 <th className="px-4 py-2">PAN ID</th>
//                 <th className="px-4 py-2">Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {currentData.length > 0 ? (
//                 currentData.map((item, idx) => (
//                   <tr key={idx} className="border-t hover:bg-gray-50">
//                     <td className="px-4 py-2">
//                       {(currentPage - 1) * itemsPerPage + idx + 1}
//                     </td>
//                     <td className="px-4 py-2">{item.date}</td>
//                     <td className="px-4 py-2 font-mono">{item.panNo}</td>
//                     <td className="px-4 py-2">
//                       <span
//                         className={`px-2 py-1 rounded text-white text-xs ${
//                           item.status === "Success"
//                             ? "bg-green-500"
//                             : "bg-red-500"
//                         }`}
//                       >
//                         {item.status}
//                       </span>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td
//                     colSpan="4"
//                     className="px-4 py-4 text-center text-gray-500"
//                   >
//                     No records found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>

//           <div className="flex flex-col md:flex-row items-center justify-between mt-4">
//             <span className="text-sm text-gray-500">
//               Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
//               {Math.min(currentPage * itemsPerPage, filteredHistory.length)} of{" "}
//               {filteredHistory.length} entries
//             </span>

//             <div className="flex gap-2 mt-2 md:mt-0">
//               <button
//                 onClick={handlePrev}
//                 disabled={currentPage === 1}
//                 className="px-3 py-1 border rounded text-sm disabled:opacity-50"
//               >
//                 Prev
//               </button>

//               {visiblePages[0] > 1 && <span className="px-2">...</span>}
//               {visiblePages.map((p) => (
//                 <button
//                   key={p}
//                   onClick={() => setCurrentPage(p)}
//                   className={`px-3 py-1 border rounded text-sm ${
//                     currentPage === p ? "bg-blue-600 text-white" : ""
//                   }`}
//                 >
//                   {p}
//                 </button>
//               ))}
//               {visiblePages[visiblePages.length - 1] < totalPages && (
//                 <span className="px-2">...</span>
//               )}

//               <button
//                 onClick={handleNext}
//                 disabled={currentPage === totalPages}
//                 className="px-3 py-1 border rounded text-sm disabled:opacity-50"
//               >
//                 Next
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//       //console.log("---------------", panPrice);
//       {showConfirmationModal && (
//         <PortalModal>
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//             <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
//               <h3 className="text-lg font-semibold mb-4">Confirm Payment</h3>
//               <p className="mb-4">
//                 This PAN verification will cost you{" "}
//                 <span className="text-red-600"> ₹{panPrice} </span>. Do you want
//                 to proceed?
//               </p>
//               <div className="flex justify-end gap-4">
//                 <button
//                   onClick={() => setShowConfirmationModal(false)}
//                   className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   onClick={() => {
//                     setShowConfirmationModal(false);
//                     proceedWithApiCall();
//                   }}
//                   className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
//                 >
//                   Confirm & Pay
//                 </button>
//               </div>
//             </div>
//           </div>
//         </PortalModal>
//       )}
//       {showCard && panData && (
//         <PortalModal>
//           <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
//             <div className="bg-white rounded-lg shadow-lg p-4 max-w-md w-full">
//               <div
//                 id="printPanArea"
//                 className="mx-auto"
//                 style={{ width: "24.8rem", height: "15.8rem" }}
//               >
//                 <div
//                   className="w-full h-full rounded-xl p-3 relative box-border bg-cover bg-center"
//                   style={{
//                     backgroundImage: `url(${require("../../Assets/Logos/5.png")})`,
//                   }}
//                 >
//                   <div className="flex gap-2 mt-12">
//                     <div className="w-[60px] h-[60px] border">
//                       <img
//                         src={uploadedImageUrl}
//                         alt="User"
//                         className="w-full h-full object-cover"
//                       />
//                     </div>

//                     <div className="flex-1 text-center">
//                       <p className="text-[10px] font-bold tracking-tight text-blue-900">
//                         स्थायी लेखा संख्या कार्ड
//                       </p>
//                       <p className="text-[10px] font-bold tracking-tight text-blue-900">
//                         Permanent Account Number Card
//                       </p>
//                       <p className="text-sm font-bold tracking-widest text-black">
//                         {panData.pan_number}
//                       </p>
//                     </div>

//                     <div className="bg-white p-[0.17rem]">
//                       <QRCodeCanvas value={qrText} level="H" size={80} />
//                     </div>
//                   </div>

//                   <div className="text-[9.5px] absolute left-3 right-3 bottom-3">
//                     <p className="flex flex-col  ">
//                       <strong className="text-blue-900">नाम/ Name:</strong>
//                       <strong>{panData.full_name}</strong>
//                     </p>

//                     <p className="flex flex-col mt-1">
//                       <strong className="text-blue-900">
//                         पिता का नाम / Father's Name:
//                       </strong>
//                       <strong>{panData.father_name}</strong>
//                     </p>

//                     <div className="flex justify-between items-end mt-2">
//                       <p className="flex flex-col">
//                         <strong className="text-blue-900">
//                           जन्म की तारीख /{" "}
//                           <span className="flex">Date of Birth:</span>
//                         </strong>
//                         <strong>{formatDate(panData.dob)}</strong>
//                       </p>

//                       {/* Signature Box */}
//                       <div
//                         className="bg-white ml-10 py-2 px-3 rounded-sm flex items-center justify-center border border-gray-300"
//                         style={{
//                           width: "7rem",
//                           height: "3rem",
//                           minWidth: "7rem",
//                           minHeight: "3rem",
//                           display: "flex",
//                           alignItems: "center",
//                           justifyContent: "center",
//                         }}
//                       >
//                         {uploadedSignatureUrl ? (
//                           <img
//                             src={uploadedSignatureUrl}
//                             alt="Signature"
//                             className="object-contain"
//                             style={{
//                               width: "100%",
//                               height: "100%",
//                               objectFit: "contain",
//                               padding: "2px",
//                             }}
//                           />
//                         ) : (
//                           <div
//                             style={{
//                               color: "#9CA3AF",
//                               fontSize: "12px",
//                               textAlign: "center",
//                               fontWeight: "500",
//                             }}
//                           ></div>
//                         )}
//                       </div>

//                       <div className="flex flex-col mb-2 text-[4px] text-black">
//                         <div className="flex items-center">
//                           <p className="ml-3">
//                             PAN Application Digitally Signed Card Not
//                           </p>
//                         </div>
//                         <p className="ml-[0.8rem]">
//                           Valid unless Physically Signed
//                         </p>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {showCard && (
//                 <div
//                   style={{
//                     position: "absolute",
//                     top: "-9999px",
//                     left: "-9999px",
//                     width: "842pt",
//                     height: "595pt",
//                     backgroundColor: "#ffffff",
//                     padding: "20pt",
//                   }}
//                   ref={pdfRef}
//                 >
//                   <PanCardPdf
//                     panData={panData}
//                     uploadedImageUrl={uploadedImageUrl}
//                     uploadedSignatureUrl={uploadedSignatureUrl}
//                     qrText={qrText}
//                   />
//                 </div>
//               )}

//               <div className="mt-4 flex justify-between">
//                 <button
//                   onClick={() => setShowCard(false)}
//                   className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400"
//                 >
//                   Close
//                 </button>
//                 <button
//                   onClick={handleDownloadPDF}
//                   disabled={isDownloadingPDF}
//                   className={`bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700 ${
//                     isDownloadingPDF ? "opacity-50 cursor-not-allowed" : ""
//                   }`}
//                 >
//                   {isDownloadingPDF ? "Downloading..." : "Download PDF"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </PortalModal>
//       )}
//     </div>
//   );
// }

import React, { useMemo, useRef, useState } from "react";
import { BsFiletypePdf } from "react-icons/bs";
import PortalModal from "../PortalModal";
import img from "../../Assets/Logos/profile3.jpg";
import { QRCodeCanvas } from "qrcode.react";
import logo from "../../Assets/Logos/ashok.png";
import html2pdf from "html2pdf.js";
import { toast } from "react-toastify";
import axios from "axios";
import { useEffect } from "react";
import PanCardPdf from "../PanCardPdf";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useAssets } from "../../Context/AssetsContext";

const REACT_APP_CLOUDINARY_UPLOAD_URL =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_URL;
const REACT_APP_CLOUDINARY_UPLOAD_PRESET =
  process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;

export default function PanCard() {
  const { assetsReady, assets } = useAssets();
  const [panNo, setPanNo] = useState("");
  const [history, setHistory] = useState([]);
  const previewRef = useRef(null);
  const pdfRef = useRef(null);
  const fileInputRef = useRef(null);
  const signatureInputRef = useRef(null);
  const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

  const [panPrice, setPanPrice] = useState(null);
  const [panAccess, setPanAccess] = useState(false);
  const [allHistory, setAllHistory] = useState([]);
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [panData, setPanData] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const panCardRef = useRef(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isDownloadingPDF, setIsDownloadingPDF] = useState(false);
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });

  const [uploading, setUploading] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedSignatureUrl, setUploadedSignatureUrl] = useState("");
  const [selectedSignatureFile, setSelectedSignatureFile] = useState(null);

  const fetchPriceData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      setPanAccess(response.data?.serviceAccess.includes("pan"));
      setPanPrice(response?.data?.servicePrices?.pan);
    } catch (e) {
      console.error("Error fetching data:", e);
    }
  };

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/get-document-records?service=pan`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      const historyData = response.data.map((item) => ({
        date: new Date(item.createdAt).toLocaleString(),
        panNo: item.idNumber,
        name: item.apiResponse?.name || "N/A",
        details: "PAN Verification",
        status: item.status.charAt(0).toUpperCase() + item.status.slice(1),
        error: item.status === "failed" ? "Verification failed" : "",
        createdAt: new Date(item.createdAt),
      }));

      setAllHistory(historyData);
      setFilteredHistory(historyData);
      setHistory(historyData);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch history");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    fetchPriceData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [filters]);

  const handleSubmit = async () => {
    if (!panNo.trim()) {
      toast.error("Please enter PAN number");
      return;
    }
    if (!panAccess) {
      toast.error("You don't have access to this service");
      return;
    }
    if (!selectedFile) {
      toast.error("Please upload a photo first");
      return;
    }

    try {
      setUploading(true);

      const photoFormData = new FormData();
      photoFormData.append("file", selectedFile);
      photoFormData.append("upload_preset", REACT_APP_CLOUDINARY_UPLOAD_PRESET);

      const photoRes = await axios.post(
        REACT_APP_CLOUDINARY_UPLOAD_URL,
        photoFormData,
      );
      const imageUrl = photoRes.data.secure_url;
      setUploadedImageUrl(imageUrl);

      if (selectedSignatureFile) {
        const signatureFormData = new FormData();
        signatureFormData.append("file", selectedSignatureFile);
        signatureFormData.append(
          "upload_preset",
          REACT_APP_CLOUDINARY_UPLOAD_PRESET,
        );

        const signatureRes = await axios.post(
          REACT_APP_CLOUDINARY_UPLOAD_URL,
          signatureFormData,
        );
        const signatureUrl = signatureRes.data.secure_url;
        setUploadedSignatureUrl(signatureUrl);
      }

      toast.success("Photo uploaded successfully!");
      setShowConfirmationModal(true);
    } catch (error) {
      console.error("Upload failed:", error);
      toast.error("Upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const proceedWithApiCall = async () => {
    if (!panNo.trim()) {
      toast.error("Please enter PAN number");
      return;
    }

    setIsLoading(true);
    setError("");
    setPanData(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/pan/pan-comprehensive-verification`,
        {
          id_number: panNo,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success === false) {
        throw new Error(response.data.message || "Failed to fetch PAN data");
      }

      setPanData(response.data.data);
      setShowCard(true);

      const newEntry = {
        date: new Date().toLocaleString(),
        panNo: response.data.data.pan_number,
        name: response.data.data.full_name || "N/A",
        dob: response.data.data.dob || "N/A",
        status: "Success",
      };

      setAllHistory((prev) => [newEntry, ...prev]);
      setFilteredHistory((prev) => [newEntry, ...prev]);
      setHistory((prev) => [newEntry, ...prev]);

      toast.success("PAN data fetched successfully");
    } catch (err) {
      console.error("Error fetching PAN data:", err);

      let errorMessage = "Failed to fetch PAN data. Please try again.";
      if (err.response) {
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized - Please login again";
        } else if (err.response.status === 403) {
          errorMessage = "Forbidden - You don't have permission";
        } else if (err.response.status === 404) {
          errorMessage = "Service not found";
        } else if (err.response.status === 500) {
          errorMessage = "Server error - Please try again later";
        }
      } else if (err.request) {
        errorMessage = "Network error - Please check your connection";
      }

      toast.error(errorMessage);

      const newEntry = {
        date: new Date().toLocaleString(),
        panNo,
        status: "Failed",
        error: errorMessage,
      };

      setAllHistory((prev) => [newEntry, ...prev]);
      setFilteredHistory((prev) => [newEntry, ...prev]);
      setHistory((prev) => [newEntry, ...prev]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    applyFilters();
  }, [filters, allHistory]);

  const applyFilters = () => {
    let filteredData = [...allHistory];

    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      filteredData = filteredData.filter(
        (item) =>
          item.panNo.toLowerCase().includes(searchTerm) ||
          (item.name && item.name.toLowerCase().includes(searchTerm)),
      );
    }

    if (filters.status) {
      filteredData = filteredData.filter(
        (item) => item.status.toLowerCase() === filters.status.toLowerCase(),
      );
    }

    if (filters.fromDate || filters.toDate) {
      const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
      const toDate = filters.toDate ? new Date(filters.toDate) : null;

      if (fromDate) fromDate.setHours(0, 0, 0, 0);
      if (toDate) toDate.setHours(23, 59, 59, 999);

      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.createdAt);
        let matches = true;

        if (fromDate && itemDate < fromDate) matches = false;
        if (toDate && itemDate > toDate) matches = false;

        return matches;
      });
    }

    setFilteredHistory(filteredData);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      fromDate: "",
      toDate: "",
    });
    setFilteredHistory(allHistory);
    setCurrentPage(1);
  };

  const handleDownloadPDF = async () => {
    if (!assetsReady) {
      toast.warning("Please wait, card templates are still preloading...");
      return;
    }

    if (isDownloadingPDF) {
      toast.warning("PDF download is already in progress");
      return;
    }

    if (!pdfRef.current || !panData) {
      toast.error("Nothing to download");
      return;
    }

    try {
      setIsDownloadingPDF(true);

      await new Promise((res) => setTimeout(res, 300));

      const canvas = await html2canvas(pdfRef.current, {
        scale: 2,
        useCORS: true,
        backgroundColor: "#ffffff",
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("portrait", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const ratio = Math.min(
        pageWidth / canvas.width,
        pageHeight / canvas.height,
      );
      const imgWidth = canvas.width * ratio;
      const imgHeight = canvas.height * ratio;

      const marginX = (pageWidth - imgWidth) / 2;
      const marginY = 30;

      pdf.addImage(imgData, "PNG", marginX, marginY, imgWidth, imgHeight);
      pdf.save(`PAN-${panData.pan_number || "Card"}.pdf`);

      toast.success("PAN Card PDF downloaded successfully!");

      setTimeout(() => {
        setPanNo("");
        setSelectedFile(null);
        setSelectedSignatureFile(null);
        setUploadedImageUrl("");
        setUploadedSignatureUrl("");
        setPanData(null);
        setShowCard(false);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
        if (signatureInputRef.current) {
          signatureInputRef.current.value = "";
        }
      }, 500);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PAN Card PDF. Please try again.");
    } finally {
      setIsDownloadingPDF(false);
    }
  };

  const totalPages = Math.ceil(filteredHistory.length / itemsPerPage);
  const currentData = filteredHistory.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const [year, month, day] = dateString.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleSignatureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedSignatureFile(file);
    }
  };

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const visiblePages = useMemo(() => {
    const delta = 2;
    const pages = [];
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  }, [currentPage, totalPages]);

  const qrText = panData
    ? `
नाम / Name : ${panData.full_name.toUpperCase()} ,
पिता का नाम / Father's Name : ${panData.father_name.toUpperCase()},
जन्म की तारीख / Date of Birth : ${formatDate(panData.dob)},
पैन / PAN : ${panData.pan_number}
`.trim()
    : "";

  // ✅ SIGNATURE BOX COMPONENT - Reusable for both preview and PDF
  const SignatureBox = () => {
    return (
      <div
        className={`flex items-center justify-center rounded-sm  overflow-hidden ${
          uploadedSignatureUrl ? "bg-transparent" : "border-gray-300 bg-white"
        }`}
        style={{
          minWidth: "7rem",
          minHeight: "2.5rem",
          maxWidth: "16rem",
          maxHeight: "1.7rem",
          aspectRatio: "5/2",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0.25rem",
          boxSizing: "border-box",
        }}
      >
        {uploadedSignatureUrl ? (
          <img
            src={uploadedSignatureUrl}
            alt="Signature"
            className="object-contain"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "auto",
              height: "auto",
              display: "block",
            }}
          />
        ) : (
          <div
            style={{
              color: "#9CA3AF",
              fontSize: "12px",
              textAlign: "center",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              height: "100%",
            }}
          ></div>
        )}
      </div>
    );
  };

  return (
    <div className="py-4 w-full">
      <div className="bg-blue-100 p-2 mb-4">
        <h2 className="text-center text-xl font-semibold text-blue-700">
          Download PAN Card
        </h2>
      </div>
      <div className="py-4 space-y-4">
        <div className="w-full">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            PAN Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            placeholder="Enter PAN No"
            value={panNo}
            onChange={(e) => setPanNo(e.target.value.toUpperCase())}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            maxLength={10}
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Photo <span className="text-red-500">*</span>
            </label>
            <div className="relative">
              <input
                ref={fileInputRef}
                type="file"
                accept="image/*"
                onChange={handleFileUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer border border-gray-300 rounded-md pr-10"
              />
              {selectedFile && (
                <button
                  type="button"
                  onClick={() => {
                    setSelectedFile(null);
                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                    }
                  }}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-700 font-bold text-lg"
                  title="Remove photo"
                >
                  ✕
                </button>
              )}
            </div>
            {selectedFile && (
              <p className="mt-1 text-xs text-green-600">
                ✓ {selectedFile.name}
              </p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Signature
            </label>
            <div className="relative">
              <input
                ref={signatureInputRef}
                type="file"
                accept="image/*"
                onChange={handleSignatureUpload}
                className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer border border-gray-300 rounded-md pr-10"
              />
              {selectedSignatureFile && (
                <button
                  type="button"
                  onClick={() => {
                    setSelectedSignatureFile(null);
                    if (signatureInputRef.current) {
                      signatureInputRef.current.value = "";
                    }
                  }}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-500 hover:text-red-700 font-bold text-lg"
                  title="Remove signature"
                >
                  ✕
                </button>
              )}
            </div>
            {selectedSignatureFile && (
              <p className="mt-1 text-xs text-green-600">
                ✓ {selectedSignatureFile.name}
              </p>
            )}
          </div>
        </div>

        <button
          onClick={handleSubmit}
          disabled={isLoading || !panNo || !selectedFile || uploading}
          className={`bg-indigo-600 text-white py-2 px-6 rounded hover:bg-indigo-700 transition-colors ${
            isLoading || !panNo || !selectedFile || uploading
              ? "opacity-70 cursor-not-allowed"
              : ""
          }`}
        >
          {uploading ? "Uploading..." : isLoading ? "Processing..." : "SUBMIT"}
        </button>
      </div>
      <div className="bg-white p-4 shadow-md rounded-lg mb-4">
        <h3 className="text-lg font-semibold mb-4">
          PAN Card Download History
        </h3>

        <div className="bg-gray-50 p-4 rounded-lg mb-4">
          <h4 className="text-md font-medium mb-3">Filter Current Results</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
            <div>
              <label className="block text-sm font-medium mb-1">Search</label>
              <input
                type="text"
                placeholder="Search PAN number"
                value={filters.search}
                onChange={(e) =>
                  setFilters({ ...filters, search: e.target.value })
                }
                className="w-full border border-gray-300 rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Status</label>
              <select
                value={filters.status}
                onChange={(e) =>
                  setFilters({ ...filters, status: e.target.value })
                }
                className="w-full border rounded px-3 py-2"
              >
                <option value="">All Status</option>
                <option value="Success">Success</option>
                <option value="Failed">Failed</option>
                <option value="pending">Pending</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">
                From Date
              </label>
              <input
                type="date"
                value={filters.fromDate}
                onChange={(e) =>
                  setFilters({ ...filters, fromDate: e.target.value })
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">To Date</label>
              <input
                type="date"
                value={filters.toDate}
                onChange={(e) =>
                  setFilters({ ...filters, toDate: e.target.value })
                }
                className="w-full border rounded px-3 py-2"
              />
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <button
              onClick={clearFilters}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-400"
            >
              Clear
            </button>
            <button
              onClick={applyFilters}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Apply
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                <th className="px-4 py-2">Sl No</th>
                <th className="px-4 py-2">Date & Time</th>
                <th className="px-4 py-2">PAN ID</th>
                <th className="px-4 py-2">Status</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((item, idx) => (
                  <tr key={idx} className="border-t hover:bg-gray-50">
                    <td className="px-4 py-2">
                      {(currentPage - 1) * itemsPerPage + idx + 1}
                    </td>
                    <td className="px-4 py-2">{item.date}</td>
                    <td className="px-4 py-2 font-mono">{item.panNo}</td>
                    <td className="px-4 py-2">
                      <span
                        className={`px-2 py-1 rounded text-white text-xs ${
                          item.status === "Success"
                            ? "bg-green-500"
                            : "bg-red-500"
                        }`}
                      >
                        {item.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="4"
                    className="px-4 py-4 text-center text-gray-500"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="flex flex-col md:flex-row items-center justify-between mt-4">
            <span className="text-sm text-gray-500">
              Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
              {Math.min(currentPage * itemsPerPage, filteredHistory.length)} of{" "}
              {filteredHistory.length} entries
            </span>

            <div className="flex gap-2 mt-2 md:mt-0">
              <button
                onClick={handlePrev}
                disabled={currentPage === 1}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Prev
              </button>

              {visiblePages[0] > 1 && <span className="px-2">...</span>}
              {visiblePages.map((p) => (
                <button
                  key={p}
                  onClick={() => setCurrentPage(p)}
                  className={`px-3 py-1 border rounded text-sm ${
                    currentPage === p ? "bg-blue-600 text-white" : ""
                  }`}
                >
                  {p}
                </button>
              ))}
              {visiblePages[visiblePages.length - 1] < totalPages && (
                <span className="px-2">...</span>
              )}

              <button
                onClick={handleNext}
                disabled={currentPage === totalPages}
                className="px-3 py-1 border rounded text-sm disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {showConfirmationModal && (
        <PortalModal>
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
              <h3 className="text-lg font-semibold mb-4">Confirm Payment</h3>
              <p className="mb-4">
                This PAN verification will cost you{" "}
                <span className="text-red-600 font-bold">
                  ₹{panPrice || "N/A"}
                </span>
                . Do you want to proceed?
              </p>
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowConfirmationModal(false)}
                  className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    setShowConfirmationModal(false);
                    proceedWithApiCall();
                  }}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Confirm & Pay
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
      {showCard && panData && (
        <PortalModal>
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
            <div className="bg-white rounded-lg shadow-lg p-4 max-w-md w-full">
              <div
                id="printPanArea"
                className="mx-auto"
                style={{ width: "24.8rem", height: "15.8rem" }}
              >
                <div
                  className="w-full h-full rounded-xl p-3 relative box-border bg-cover bg-center"
                  style={{
                    backgroundImage: `url(${assets.panFront})`,
                  }}
                >
                  <div className="flex gap-2 mt-12">
                    <div className="w-[60px] h-[60px] border">
                      <img
                        src={uploadedImageUrl}
                        alt="User"
                        className="w-full h-full object-cover"
                      />
                    </div>

                    <div className="flex-1 text-center">
                      <p className="text-[10px] font-bold tracking-tight text-blue-900">
                        स्थायी लेखा संख्या कार्ड
                      </p>
                      <p className="text-[10px] font-bold tracking-tight text-blue-900">
                        Permanent Account Number Card
                      </p>
                      <p className="text-sm font-bold tracking-widest text-black">
                        {panData.pan_number}
                      </p>
                    </div>

                    <div className="bg-white p-[0.17rem]">
                      <QRCodeCanvas value={qrText} level="L" size={80} />
                    </div>
                  </div>

                  <div className="text-[9.5px] absolute left-3 right-3 bottom-3">
                    <p className="flex flex-col  ">
                      <strong className="text-blue-900">नाम/ Name:</strong>
                      <strong>{panData.full_name}</strong>
                    </p>

                    <p className="flex flex-col mt-1">
                      <strong className="text-blue-900">
                        पिता का नाम / Father's Name:
                      </strong>
                      <strong>{panData.father_name}</strong>
                    </p>

                    <div className="flex justify-between items-end mt-2">
                      <p className="flex flex-col">
                        <strong className="text-blue-900">
                          जन्म की तारीख /{" "}
                          <span className="flex">Date of Birth:</span>
                        </strong>
                        <strong>{formatDate(panData.dob)}</strong>
                      </p>

                      {/* ✅ SIGNATURE BOX - PREVIEW */}
                      <div className="ml-10 ">
                        <SignatureBox />
                      </div>

                      <div className="flex flex-col mb-2 text-[4px] text-black">
                        <div className="flex items-center">
                          <p className="ml-3">
                            PAN Application Digitally Signed Card Not
                          </p>
                        </div>
                        <p className="ml-[0.8rem]">
                          Valid unless Physically Signed
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {showCard && (
                <div
                  style={{
                    position: "absolute",
                    top: "-9999px",
                    left: "-9999px",
                    width: "842pt",
                    height: "595pt",
                    backgroundColor: "#ffffff",
                    padding: "20pt",
                  }}
                  ref={pdfRef}
                >
                  <PanCardPdf
                    panData={panData}
                    uploadedImageUrl={uploadedImageUrl}
                    uploadedSignatureUrl={uploadedSignatureUrl}
                    qrText={qrText}
                  />
                </div>
              )}

              <div className="mt-4 flex justify-between">
                <button
                  onClick={() => setShowCard(false)}
                  className="bg-gray-300 px-4 py-1 rounded hover:bg-gray-400"
                >
                  Close
                </button>
                 <button
                  onClick={handleDownloadPDF}
                  disabled={isDownloadingPDF || !assetsReady}
                  className={`bg-blue-600 text-white px-4 py-1 rounded hover:bg-blue-700 ${
                    (isDownloadingPDF || !assetsReady) ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                >
                  {isDownloadingPDF ? "Downloading..." : !assetsReady ? "Loading Templates..." : "Download PDF"}
                </button>
              </div>
            </div>
          </div>
        </PortalModal>
      )}
    </div>
  );
}
